// extracted by mini-css-extract-plugin
export default {"button":"primary-alt-mini__button___RGcrl primary-mini__button___jNPId primary__button___frFdc base__button___zT0JW"};